import React from "react";

const Mobile = ({ style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36" }) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.533 2C7.688 2 7 2.657 7 3.463v3.462h21.333V3.463c0-.806-.695-1.463-1.546-1.463H8.533ZM14.6 3.5c.031-.001.062-.001.094 0h5.946a.885.885 0 0 1 .611.23c.163.15.254.356.254.57 0 .214-.091.42-.254.57a.884.884 0 0 1-.611.23h-5.947c-.471.024-.874-.314-.9-.756-.025-.442.336-.82.807-.844ZM7 8.521h21.333v18.963H7V8.52ZM7 29.087v3.463c0 .806.688 1.45 1.533 1.45h18.253c.851 0 1.547-.644 1.547-1.45v-3.463H7Zm10.667 1.175c.755 0 1.373.583 1.373 1.288 0 .705-.62 1.287-1.373 1.287-.752 0-1.373-.58-1.373-1.287s.619-1.288 1.373-1.288Z"
            fill={fill}
        />

    </svg>
);

export default Mobile;